// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchForm_form__1-crx","form__cancel":"SearchForm_form__cancel__3CFXs","form__input":"SearchForm_form__input__uDE5g","spin":"SearchForm_spin__2iqQq"};